import ReportAnswersFilters from "./components/ReportAnswersFilters";
import DateFilter from "./components/DateFilter";
import ExportModal from "./components/ExportModal";
import ReportsAnswerImages from "./components/ReportsAnswerImages";
import ReportPagination from "./components/ReportPagination";
import ReportTable from "./components/ReportTable";

import useReportsAnswersSelects from "./hooks/useReportsAnswersSelects";
import PreviewImage from "../GroupChats/PreviewImage.component";
import LoadingData from "../../../components/loadingData/loadingData.component";

import { ReportsAnswersSelects } from "./components/ReportAnswersSelects";

export default function NewReportsAnswers() {
  const {
    handleReset,
    segmentsOptions,
    getReport,
    sectorsOptions,
    sitesOptions,
    sectorValue,
    setSectorValue,
    sitevalue,
    setSiteValue,
    segmentValue,
    setSegmentValue,
    reportsCategoreisOptions,
    reportsCategories,
    setReportsCategories,
    reportsOrVoiceReports,
    setReportsOrVoiceReports,
    reports,
    setReports,
    voiceReports,
    setVoiceReports,
    reportId,
    setReportId,
    setReport,
    isLoading,
    reportsOptions,
    setVersionId,
    versionId,
    setVersionsCount,
    report,
    setToggleExportModal,
    toggleFilter,
    setToggleFilter,
    reportAnswersFlow,
    reportAnswers,
    versionsCount,
    versionOptions,
    reportVersion,
    setReportVersion,
    searchValue,
    setSearchValue,
    toggleOptions,
    setToggleOptions,
    toggleExportOptions,
    setToggleExportOptions,
    filterValues,
    setFilterValues,
    toggleExportModal,
    exportLoading,
    exportMode,
    setExportMode,
    exportExceel,
    selectedFormIds,
    selectedQuestionIds,
    handleSelectFormIds,
    handleSelectQuestionIds,
    reportAnswerImages,
    setReportAnswerImages,
    sites,
    previewImage,
    setPreviewImage,
    reportsCount,
    nestedTable,
    setNestedTable,
    nestedTableConverter,
    getDuration,
    sort,
  } = useReportsAnswersSelects();

  const newReport: any = nestedTable
    ? nestedTableConverter(report, nestedTable)
    : report;

  let reportsFormIds = !nestedTable
    ? newReport?.answers.map((answer: any) =>
        newReport?.report_type === "follow_up" ||
        newReport?.report_type === "voice_reports"
          ? answer.flow_id
          : answer.form_id
      ) || []
    : Object.keys(newReport?.answers || {}).sort(
        (a: any, b: any) => a.order - b.order
      );
  let reportsAnswers = !nestedTable
    ? newReport?.answers || []
    : Object.values(newReport?.answers || {}).sort(
        (a: any, b: any) => a.order - b.order
      );

  if (sort === "reverse") {
    // console.log("reverse");
    reportsFormIds = [...reportsFormIds].reverse();
    reportsAnswers = [...reportsAnswers].reverse();
    // console.log("after reverse", reportsAnswers.reverse());
  }
  // const reportsFormIds = !nestedTable
  //   ? Object.keys(newReport?.answers || {})
  //   : Object.keys(newReport?.answers || {}).sort(
  //       (a: any, b: any) => a.order - b.order
  //     );
  // const reportsAnswers = !nestedTable
  //   ? Object.values(newReport?.answers || {})
  //   : Object.values(newReport?.answers || {}).sort(
  //       (a: any, b: any) => a.order - b.order
  //     );

  return (
    <section>
      <ReportsAnswersSelects
        handleReset={handleReset}
        segmentsOptions={segmentsOptions}
        sectorsOptions={sectorsOptions}
        sitesOptions={sitesOptions}
        sectorValue={sectorValue}
        setSectorValue={setSectorValue}
        sitevalue={sitevalue}
        setSiteValue={setSiteValue}
        segmentValue={segmentValue}
        setSegmentValue={setSegmentValue}
        reportsCategoreisOptions={reportsCategoreisOptions}
        reportsCategories={reportsCategories}
        setReportsCategories={setReportsCategories}
        reportsOrVoiceReports={reportsOrVoiceReports}
        setReportsOrVoiceReports={setReportsOrVoiceReports}
        reports={reports}
        setReports={setReports}
        voiceReports={voiceReports}
        setVoiceReports={setVoiceReports}
        reportId={reportId}
        setReportId={setReportId}
        report={newReport}
        setReport={setReport}
        isLoading={isLoading}
        reportsOptions={reportsOptions}
        setVersionId={setVersionId}
        setVersionsCount={setVersionsCount}
        setReportVersion={setReportVersion}
        setSearchValue={setSearchValue}
      />

      {reportsOrVoiceReports.length > 0 &&
        (isLoading === "report" || isLoading === "voiceReports") && (
          <LoadingData />
        )}

      <ReportAnswersFilters
        getReport={getReport}
        report={newReport}
        setToggleExportModal={setToggleExportModal}
        toggleFilter={toggleFilter}
        setToggleFilter={setToggleFilter}
        reportAnswersFlow={reportAnswersFlow}
        isLoading={isLoading}
        reportAnswers={reportAnswers}
        reportsOrVoiceReports={reportsOrVoiceReports}
        versionsCount={versionsCount}
        versionOptions={versionOptions}
        reportVersion={reportVersion}
        setReportVersion={setReportVersion}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setNestedTable={setNestedTable}
        handleSelectFormIds={handleSelectFormIds}
        handleSelectQuestionIds={handleSelectQuestionIds}
      />

      <ReportTable
        reportsOrVoiceReports={reportsOrVoiceReports}
        reportsAnswers={reportsAnswers}
        report={newReport}
        sites={sites}
        isLoading={isLoading}
        searchValue={searchValue}
        handleSelectFormIds={handleSelectFormIds}
        selectedFormIds={selectedFormIds}
        reportsFormIds={reportsFormIds}
        handleSelectQuestionIds={handleSelectQuestionIds}
        filterValues={filterValues}
        setPreviewImage={setPreviewImage}
        setReportAnswerImages={setReportAnswerImages}
        selectedQuestionIds={selectedQuestionIds}
        sitevalue={sitevalue ?? 0}
        reportVersion={reportVersion}
        versionId={versionId}
        nestedTable={nestedTable}
        setNestedTable={setNestedTable}
        getDuration={getDuration}
      />

      <ReportPagination
        reportsCount={reportsCount}
        reportsAnswers={reportsAnswers}
        report={newReport}
      />

      <ExportModal
        setToggleExportModal={setToggleExportModal}
        toggleExportModal={toggleExportModal}
        setToggleExportOptions={setToggleExportOptions}
        toggleExportOptions={toggleExportOptions}
        exportLoading={exportLoading}
        exportMode={exportMode}
        setExportMode={setExportMode}
        exportExceel={exportExceel}
        report={newReport}
        versionId={versionId}
      />

      <DateFilter
        toggleFilter={toggleFilter}
        setToggleFilter={setToggleFilter}
        report={newReport}
        reportAnswers={reportAnswers}
        reportAnswersFlow={reportAnswersFlow}
        toggleOptions={toggleOptions}
        setToggleOptions={setToggleOptions}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
      />

      <ReportsAnswerImages
        reportAnswerImages={reportAnswerImages}
        setReportAnswerImages={setReportAnswerImages}
      />

      {previewImage && (
        <PreviewImage src={previewImage} setSrc={setPreviewImage} />
      )}
    </section>
  );
}
